"use client";

import { useCallback, useEffect, useState } from "react";
import { loadWordList } from "@/lib/tool-kit/vocabulary/anagram";

export type WordListStatus = "idle" | "loading" | "ready" | "error";

/**
 * The ENABLE word list the Anagram Solver uses, fetched once per page load.
 *
 * Nothing is requested until `wanted` turns true — a visitor who only reads the page
 * never downloads the list. `retry` forgets a failed fetch and asks again.
 */
export function useWordList(wanted: boolean) {
  const [words, setWords] = useState<string[] | null>(null);
  const [status, setStatus] = useState<WordListStatus>("idle");

  useEffect(() => {
    if (!wanted || status !== "idle") {
      return;
    }
    setStatus("loading");
    loadWordList()
      .then((list) => {
        setWords(list);
        setStatus("ready");
      })
      .catch(() => setStatus("error"));
  }, [wanted, status]);

  const retry = useCallback(() => setStatus("idle"), []);
  return { words, status, retry };
}
